import { HttpRequest, createRequestBuilder, createHttpClient, HttpResponse } from '@quickplay/foundation';

export function fetchVASTDocument(vastUrl: string): Promise<string> {
  return new Promise((resolve, reject) => {
    const request: HttpRequest<any> = createRequestBuilder()
      .url(vastUrl)
      .get()
      .options({ disableEncode: true })
      .responseFormat('text')
      .build();
    const httpClient = createHttpClient<any, string>();
    httpClient
      .callWith(request)
      .then((response: HttpResponse<string>) => {
        if (response.body) {
          resolve(response.body);
        }
      })
      .catch((error: any) => {
        reject(error);
      });
  });
}
